import { Injectable } from '@angular/core';
import { GenericMessage } from '@app/interfaces/globals';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { WrapToasterService } from '@app/services/wrap-toaster-service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IInvitedUser, InviteResponse, IUserInterface } from './user.interface';
import { UserService } from '@app/services/user/user.service';

@Injectable({
	providedIn: 'root',
})
export class UsersApi {
	constructor(
		private apiFacade: ApiFacadeService,
		private toasterService: WrapToasterService,
		private userService: UserService,
	) {}

	getAll(): Observable<IUserInterface[]> {
		const url = 'frontend/account/get-users';

		return this.apiFacade.get<{ users: IUserInterface[] }>(url).pipe(
			map((data) => data.users),
			catchError((error) => {
				this.toasterService.handleRequestFailed(error);
				return of([]);
			}),
		);
	}

	changeStatus(user: IUserInterface): Observable<GenericMessage> {
		const url = 'frontend/account/change_status';
		const payload = {
			user_uuid: user.uuid,
			user_name: user.user_name,
			new_status: user.enabled,
		};

		return this.apiFacade.post<GenericMessage>(url, payload);
	}

	public invite(payload: IInvitedUser, fromAdmin = false): Observable<InviteResponse> {
		const url = fromAdmin ? 'admin/users/invite' : 'frontend/invite-user';

		return this.apiFacade.post<InviteResponse>(url, {
			org_id: this.userService.organizationId,
			is_new_reseller: false,
			...payload,
		});
	}
}
